export const judgeWhetherUseMultilingual = () => {
  return true;
  // return ['.staging', ':3000', 'sandbox'].some((item) =>
  //   window.location.href.includes(item)
  // );
};
